import { cx } from '../lib/cx';

export interface MeasurementRow {
  label: string;
  value: number | null;
  unit: string;
  delta?: number | null;
}

export interface MeasurementCardProps {
  dateLabel: string;
  rows: readonly MeasurementRow[];
  note?: string | null;
  className?: string;
}

export function MeasurementCard({ dateLabel, rows, note, className }: MeasurementCardProps) {
  const visible = rows.filter((r) => r.value !== null);
  return (
    <article
      className={cx(
        'rounded-xl border border-line-subtle bg-surface p-4 shadow-card',
        className,
      )}
    >
      <p className="eyebrow mb-3">{dateLabel}</p>
      <dl className="grid grid-cols-2 gap-x-4 gap-y-3 sm:grid-cols-3">
        {visible.map((r) => (
          <div key={r.label}>
            <dt className="text-[12px] text-ink-muted">{r.label}</dt>
            <dd className="font-display text-[21px] font-semibold text-ink">
              {r.value}
              <span className="ml-1 font-body text-[12px] text-ink-muted">{r.unit}</span>
              {r.delta != null && r.delta !== 0 && (
                <span
                  className={cx(
                    'ml-2 font-body text-[12px]',
                    r.delta < 0 ? 'text-success-dark' : 'text-warning-dark',
                  )}
                >
                  {r.delta > 0 ? '+' : ''}
                  {Math.round(r.delta * 10) / 10}
                </span>
              )}
            </dd>
          </div>
        ))}
      </dl>
      {note && <p className="mt-3 text-[13px] leading-relaxed text-ink-muted">{note}</p>}
    </article>
  );
}
